import { bridgeConverter } from '../../bridge/bridgeConverter.tsx';
import { ExternalImportFileList } from '../../react/product/import/ExternalImportFileList.tsx';
import { FooBar } from '../../react/FooBar';
import { MetaFieldValues } from '../../react/MetaFieldValues';
import { MetaFields } from '../../react/MetaFields';
import { ColourChange } from '../../react/product/colourChange'
import { AssortmentPlanning } from '../../react/purchasing/assortmentPlanning'

angular
  .module('app.bridgeComponents', [])
  .component('fooBar', bridgeConverter(FooBar, ['hello']))
  .component('metaFieldValues', bridgeConverter(MetaFieldValues, ['values', 'initialIsEditing']))
  .component('metaFields', bridgeConverter(MetaFields, ['fields', 'initialIsEditing']))
  .component('colourChange', bridgeConverter(ColourChange, ['articleId']))
  .component('externalImportFileList', bridgeConverter(ExternalImportFileList, []))
  .component('assortmentPlanning', bridgeConverter(AssortmentPlanning, ['hi']));
